// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__e6fsD","fileBtn":"File_fileBtn__2FzBS","closeBtn":"File_closeBtn__2ebqb","fileSelected":"File_fileSelected__UP3vQ","disabled":"File_disabled__22Apr"};